export default __webpack_public_path__ + "static/media/luis.c322e29e.png";